// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_-xM","cls2":"ResearchInterestSearchResults-cls2_aYw ResearchInterestSearchResults-cls1_-xM"};